<section class="builder-page-container">
  <div class="page-content"
       (click)="onClickPage()"
       [class.selected]="selected"
       [class.edit-mode]="pageEditMode">
    <db-builder-page-title [page]="page"
                           [isSinglePage]="isSinglePage"
                           [class.disabled]="isMobile"
                           (dbClickOutside)="clickOutside()"
                           (selectPage)="onSelectPage()"
                           [selected]="selected"
                           [pageEditData]="pageEditData"
                           (cancelEdit)="cancelPageEdit($event)"
                           (regeneratePage)="regeneratePage()"
                           (regeneratePageWithEcommType)="regeneratePageWithEcommType($event)"
                           (onDeletePage)="showEditTooltip=false;onDeletePage.emit()"
                           (onPageEdit)="onPageEdit($event)"
                           (pageEditMode)="pageEditMode = $event"
                           [loading]="loading">
    </db-builder-page-title>
    <db-builder-page-body [page]="page"
                          [needRegeneration]="needRegeneration"
                          [class.disabled]="pageEditData.loading || isMobile"
                          [enhanceObservable]="enhanceResponse"
                          (sectionsListChanged)="onSectionsListChange($event)"
                          (sectionTypeChange)="sectionTypeChange.emit($event)"
                          (enhance)="enhanceSection($event)"
                          [sectionTemplates]="sectionTemplates"
                          (sectionSelected)="resetTitleEdit()"
                          (loadingChanged)="loading = $event"
                          [pageWithSections]="pageWithSections">
    </db-builder-page-body>
  </div>
</section>
